module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"caption":"Drag a file into this box, or click on it to upload a file","fileAttached":"File attached"},"es":{"caption":"Arrastre un archivo a este cuadro o haga clic en él para cargar un archivo","fileAttached":"Archivo adjunto"},"sw":{"caption":"Buruta faili kwenye kisanduku hiki, au ubofye juu yake ili kupakia faili","fileAttached":"Faili imeambatishwa"}}')
  delete Component.options._Ctor
}
